"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.resolveVariable = exports.resolveNumberOrString = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var resolveNumberOrString = function resolveNumberOrString(val) {
  if ((0, _ramda.isNil)(val) || !((0, _ramda.is)(String, val) || (0, _ramda.is)(Number, val))) {
    return '';
  }

  return (0, _ramda.is)(String, val) ? val : "\n          ".concat(val, "px;\n        ");
};

exports.resolveNumberOrString = resolveNumberOrString;

var resolveVariable = function resolveVariable(var1, var2) {
  if ((0, _ramda.isNil)(var1)) {
    return var2;
  }

  return var1;
};
/**
 * A completely generic component for when you need some arbitrary styling added to it. Useful for those minor wrapper components
 */


exports.resolveVariable = resolveVariable;

var _StyledDiv = (0, _styledComponents["default"])("div").withConfig({
  displayName: "Wrapper___StyledDiv",
  componentId: "sc-19riblc-0"
})(["&&{background:", ";color:", ";border:", ";border-radius:", ";display:", ";max-height:", ";height:", ";opacity:", ";max-width:", ";width:", ";font-size:", ";font-weight:", ";font-style:", ";text-align:", ";margin:", ";margin-bottom:", ";margin-left:", ";margin-right:", ";margin-top:", ";padding:", ";padding-bottom:", ";padding-left:", ";padding-right:", ";padding-top:", ";", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
}, function (p) {
  return p._css7;
}, function (p) {
  return p._css8;
}, function (p) {
  return p._css9;
}, function (p) {
  return p._css10;
}, function (p) {
  return p._css11;
}, function (p) {
  return p._css12;
}, function (p) {
  return p._css13;
}, function (p) {
  return p._css14;
}, function (p) {
  return p._css15;
}, function (p) {
  return p._css16;
}, function (p) {
  return p._css17;
}, function (p) {
  return p._css18;
}, function (p) {
  return p._css19;
}, function (p) {
  return p._css20;
}, function (p) {
  return p._css21;
}, function (p) {
  return p._css22;
}, function (p) {
  return p._css23;
}, function (p) {
  return p._css24;
}, function (p) {
  return p._css25;
});

var Wrapper = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      background = _ref.background,
      color = _ref.color,
      display = _ref.display,
      opacity = _ref.opacity,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'div' : _ref$component,
      p = _ref.p,
      pb = _ref.pb,
      pl = _ref.pl,
      pr = _ref.pr,
      pt = _ref.pt,
      px = _ref.px,
      py = _ref.py,
      m = _ref.m,
      mb = _ref.mb,
      ml = _ref.ml,
      mr = _ref.mr,
      mt = _ref.mt,
      mx = _ref.mx,
      my = _ref.my,
      maxHeight = _ref.maxHeight,
      height = _ref.height,
      maxWidth = _ref.maxWidth,
      width = _ref.width,
      border = _ref.border,
      borderRadius = _ref.borderRadius,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      fontStyle = _ref.fontStyle,
      textAlign = _ref.textAlign,
      cssProp = _ref.css,
      props = _objectWithoutProperties(_ref, ["children", "background", "color", "display", "opacity", "component", "p", "pb", "pl", "pr", "pt", "px", "py", "m", "mb", "ml", "mr", "mt", "mx", "my", "maxHeight", "height", "maxWidth", "width", "border", "borderRadius", "fontSize", "fontWeight", "fontStyle", "textAlign", "css"]);

  return /*#__PURE__*/_react["default"].createElement(_StyledDiv, _extends({
    ref: ref // @ts-ignore
    ,
    as: component
  }, props, {
    _css: background,
    _css2: color,
    _css3: border,
    _css4: borderRadius,
    _css5: display,
    _css6: resolveNumberOrString(maxHeight),
    _css7: resolveNumberOrString(height),
    _css8: !(0, _ramda.isNil)(opacity) && opacity,
    _css9: resolveNumberOrString(maxWidth),
    _css10: resolveNumberOrString(width),
    _css11: resolveNumberOrString(fontSize),
    _css12: fontWeight,
    _css13: fontStyle,
    _css14: textAlign,
    _css15: resolveNumberOrString(m),
    _css16: resolveNumberOrString(resolveVariable(mb, my)),
    _css17: resolveNumberOrString(resolveVariable(ml, mx)),
    _css18: resolveNumberOrString(resolveVariable(mr, mx)),
    _css19: resolveNumberOrString(resolveVariable(mt, my)),
    _css20: resolveNumberOrString(p),
    _css21: resolveNumberOrString(resolveVariable(pb, py)),
    _css22: resolveNumberOrString(resolveVariable(pl, px)),
    _css23: resolveNumberOrString(resolveVariable(pr, px)),
    _css24: resolveNumberOrString(resolveVariable(pt, py)),
    _css25: cssProp
  }), children);
});
var _default = Wrapper;
exports["default"] = _default;